<script>
    import {PATH_PREFIX} from '../../apiUrls.js';

    import {onMount} from 'svelte';
    import BasicFormLayout from '../Form/BasicFormLayout.svelte';
    import Modal from '../Modal.svelte';
    import yup, {object, string, number} from 'yup';
    import {validateForm} from '../Form/utils.js';
    import {submit} from '../Form/utils.js';
    import Errors from '../Errors.svelte';
    import {get} from '../../utils.js';
    import {sgettext} from '../../i18n.js';
    import {URL_VALIDATION_REGEX} from '../../constants.js';

    export let id = 'referenceDocumentForm';
    export let title = sgettext('$$REFERENCE_DOCUMENT$$');
    export let duplicateCheckApi = `${PATH_PREFIX}/old/sw/administration/documents/duplicates/`;
    export let duplicateReferenceApi = `${PATH_PREFIX}/old/sw/administration/documents/duplicate_references`;
    export let actionUrl = `${PATH_PREFIX}/sw/api/referencedocument`;
    export let onSubmit = () => console.log('submitted')
    export let editId = null;

    let schema = object().shape({
        document_name: string()
            .required(sgettext("$$PLEASE_ENTER_DOCUMENT_NAME$$"))
            .test(
                sgettext("$$DUPLICATE_1$$"),
                sgettext("$$DOCUMENT_NAME_ALREADY_EXISTS$$"),
                _ => !nameDuplicateCheckHardFail,
            ),
        document_reference: string()
            .required(sgettext("$$PLEASE_ENTER_DOCUMENT_REFERENCE$$"))
            .test(
                sgettext("$$DUPLICATE_1$$"),
                sgettext("$$DOCUMENT_REFERENCE_NUMBER_ALREADY_EXISTS$$"),
                _ => !referenceNumberDuplicateCheckHardFail,
            )
            .test('len', sgettext('$$CANNOT_EXCEED_32_CHARACTERS$$'), val => val.length <= 32),
        document_url: string().notRequired().nullable().matches(URL_VALIDATION_REGEX,{message:sgettext("$$LINK_MUST_VALID_URL$$"),excludeEmptyString:true}),
        document_description: string()
    });

    let sending = false;
    let formErrors = [];
    let isValid = true;
    let controlDescriptionBeforeEdit = '';

    let duplicateDocs = [];
    let duplicateRefs = [];
    let nameDuplicateCheckHardFail = false;
    let referenceNumberDuplicateCheckHardFail = false;

    let formModel = defaultFormModel();

    let fields = initialFields();

    async function getEditItem() {
        if (editId) {
            try {
                const response = await get(`${actionUrl}${editId}/`);
                const json = await response.json();

                if (response.ok) {
                    controlDescriptionBeforeEdit = json.description;
                    formModel = {description: json.description, icon_id: json.icon.id, name: json.name};
                }
            } catch (error) {
                console.error(error);
            }
        }
    }


    function initialFields() {
        return {
            document_name: {
                label: sgettext('$$DOCUMENT_NAME_1$$'),
                isValid: true,
                errors: null,
                handleChanged: () => {console.log('handle changed!')},
                type: 'text',
                message: sgettext('$$DOCUMENTS_SIMILAR_NAME_FOUND$$'),
                duplicateCheck: true,
                duplicateCheckApi: duplicateCheckApi,
                onCheck: handleNameDuplicate,
            },
            document_reference: {
                label: sgettext('$$REFERENCE_1$$'),
                isValid: true,
                errors: null,
                handleChanged: validateWithoutSubmit,
                type: 'text',
                message: sgettext('$$DOCUMENTS_SIMILAR_REFERENCE_NUMBER_FOUND$$'),
                duplicateCheck: true,
                duplicateCheckApi: duplicateReferenceApi,
                onCheck: handleReferenceNumberDuplicate,

            },
            document_description: {
                label: sgettext('$$DESCRIPTION$$'),
                isValid: true,
                errors: null,
                handleChanged: validateWithoutSubmit,
                type: 'text',
                multiline: true,
                required: false
            },
            document_url: {
                label: sgettext('$$DOCUMENT_HYPERLINK$$'),
                isValid: true,
                errors: null,
                required: false,
                handleChanged: validateWithoutSubmit,
                type: 'text'
            },
        }
    }

    function defaultFormModel() {
        return {
            document_name: '',
            document_reference: '',
            document_url: '',
            document_description: ''
        }
    }


    async function validateWithoutSubmit() {
        isValid = true;
        fields.document_name.isValid = true;
        fields.document_reference.isValud = true;
        await validateForm(schema, formModel);
    }

    function handleNameDuplicate(event) {
        isValid = true;
        nameDuplicateCheckHardFail = false;
        if (event.detail.length) {
            if (event.detail[0].similarity === 100) {
                isValid = false;
                nameDuplicateCheckHardFail = true;
                formErrors = sgettext('$$DOCUMENT_NAME_ALREADY_EXISTS$$');
            }
            else {
                isValid = true;
                formErrors = [];
                nameDuplicateCheckHardFail = false;
            }
        }
        else {
            isValid = true;
            formErrors = [];
            nameDuplicateCheckHardFail = false;
        }
    }

    function handleReferenceNumberDuplicate(event) {
        isValid = true;
        referenceNumberDuplicateCheckHardFail = false;
        if (event.detail.length) {
            if (event.detail[0].similarity === 100) {
                isValid = false;
                referenceNumberDuplicateCheckHardFail = true;
                formErrors = sgettext('$$DOCUMENT_REFERENCE_NUMBER_ALREADY_EXISTS$$');
            }
            else {
                isValid = true;
                formErrors = [];
                referenceNumberDuplicateCheckHardFail = false;
            }
        }
        else {
            isValid = true;
            formErrors = [];
            referenceNumberDuplicateCheckHardFail = false;
        }
    }

    async function findDuplicates() {
        isValid = true;
        fields.document_name.isValid = true;
        fields.document_reference.isValud = true;
        let jsonModel = formModel;
        let method = 'POST';
        let url = duplicateCheckApi;
        let result = await submit(url, method, jsonModel, null, true);

        await validateWithoutSubmit();
    }


    async function onSave() {
        try {
            await validateForm(schema, formModel);
            const response = await submitForm();

            if (!formErrors || formErrors.length === 0) {
                jQuery(`#${id}`).modal('hide');
                formModel = defaultFormModel();
                onSubmit();
            }

        } catch (err) {
            isValid = false;
            if (err.inner) {
                err.inner.forEach(er => {
                    fields[er.path].isValid = false;
                    fields[er.path].errors = er.message;
                });
            }
        }
    }

    async function submitForm() {
        sending = true;
        let method = 'POST';
        let url = actionUrl;
        if (editId) {
            method = 'PATCH';
            url = `${actionUrl}${editId}/`
        }

        try {
            await submit(url, method, formModel);
        } catch (error) {
            if (error.hasOwnProperty('non_field_errors')) {
                formErrors = error;
            } else {
                console.error(error);
            }
        } finally {
            sending = false;
        }
    }

    function handleClose() {
        formModel = defaultFormModel();
        isValid = true;
        sending = false;
        formErrors = null;
        fields = initialFields();
        editId = null;
    }

    onMount(async () => {

        jQuery(`#${id}`).on('show.bs.modal', function () {
            getEditItem();
        });

        jQuery(`#${id}`).on('hidden.bs.modal', function () {
            handleClose();
        });
    });
</script>

<Modal {id} {title} {onSave} true backdrop={'static'}>
  <div slot="body">
    <BasicFormLayout {id} {schema} {fields} {formModel} />
    {#if formErrors && formErrors.length > 0}
      <Errors errors={formErrors} />
    {/if}
  </div>
</Modal>

<style></style>
